import { Directive, TemplateRef, Optional } from '@angular/core';
/**
 * Represents the column footer cell template of the Kendo ExcelExport column component.
 *
 * It helps to customize the footer cell for the column.
 */
var FooterTemplateDirective = /** @class */ (function () {
    function FooterTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    FooterTemplateDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoExcelExportFooterTemplate]'
                },] },
    ];
    /** @nocollapse */
    FooterTemplateDirective.ctorParameters = function () { return [
        { type: TemplateRef, decorators: [{ type: Optional },] },
    ]; };
    return FooterTemplateDirective;
}());
export { FooterTemplateDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-excel-export/dist/es/columns/footer-template.directive.js
// module id = ../../../../@progress/kendo-angular-excel-export/dist/es/columns/footer-template.directive.js
// module chunks = vendor